<template>
    <!-- Footer -->
    <footer class="border-t border-gray-200">
        <div class="mx-auto max-w-7xl overflow-hidden px-4 sm:px-6 lg:px-8 py-20">
            <div class="text-center text-xs leading-5 text-gray-500 flex justify-center gap-4">
                <span
                    class="truncate"
                    :title="`&copy; ${dayjs().year()} oase_aej, Arbeitsgemeinschaft der Evangelischen Jugend in Deutschland e.V.`">
                    &copy; {{ dayjs().year() }} oase_aej, Arbeitsgemeinschaft der Evangelischen Jugend in Deutschland e.V.
                </span>
                <span>|</span>
                <div>
                    <NuxtLink
                        class="me-2"
                        to="/impressum">
                        Impressum
                    </NuxtLink>
                    <span>|</span>
                    <NuxtLink
                        class="me-2"
                        to="/datenschutz">
                        Datenschutz
                    </NuxtLink>
                    <span>|</span>
                    <NuxtLink
                        class="me-2"
                        to="/datenverarbeitung">
                        Datenverarbeitung
                    </NuxtLink>
                </div>
                <!--            <NuxtLink-->
                <!--                to="impressum"-->
                <!--                class="hover:text-gray-900 hover:dark:text-gray-50">-->
                <!--                Impressum-->
                <!--            </NuxtLink>-->
                <!--            <span>|</span>-->
                <!--            <NuxtLink-->
                <!--                to="privacy"-->
                <!--                class="hover:text-gray-900 hover:dark:text-gray-50">-->
                <!--                Datenschutz-->
                <!--            </NuxtLink>-->
            </div>
        </div>
    </footer>
</template>

<script setup>
import {useCmsNavItemsStore} from "@/store/cmsNavItems"

const cmsNavItemsStore = useCmsNavItemsStore()
const dayjs = useDayjs()

const cmsFooterNavItems = computed(() => {
    return cmsNavItemsStore.cmsNavItems?.filter((item) => item.showInFooterMenu).map((item) => {
        return {
            title: item.title,
            path: item.slug,
        }
    })
})
</script>
